
'use strict'

export function getChangedProperties (object, objectInitial, propertiesConfigs) {
  const properties = {}
  if (object && objectInitial && propertiesConfigs) {
    Object.keys(propertiesConfigs).forEach(propertyKey => {
      const propertyConfig = propertiesConfigs[propertyKey]

      const value = object[propertyKey]
      const valueInitial = objectInitial[propertyKey]

      if (compareValues(value, valueInitial, propertyConfig.type)) {
        const serverValue = convertValueFromClientToServer(JSON.parse(JSON.stringify(value)), propertyConfig.type, propertyConfig.recordProperties, propertyConfig)
        if (propertyConfig.type === 'table') {
          if (serverValue.add.length || serverValue.edit.length || serverValue.remove.length) {
            properties[propertyKey] = serverValue
          }
        } else {
          properties[propertyKey] = serverValue
        }
      }
    })
  }
  return properties
}

function compareValues (v1, v2, type) {
  if (type === 'table') {
    return JSON.stringify(filterTableValueServiceFields(v1)) !== JSON.stringify(filterTableValueServiceFields(v2))
  } else if (type === 'object') {
    const id1 = v1 && (v1.id || v1.key) || null
    const id2 = v2 && (v2.id || v2.key) || null
    return id1 !== id2
  } else {
    return JSON.stringify(v1) !== JSON.stringify(v2)
  }
}

function filterTableValueServiceFields (tableValue) {
  const filteredTableValue = JSON.parse(JSON.stringify(tableValue))
  filteredTableValue.forEach(tableItem => {
    Object.keys(tableItem).forEach(key => {
      if (key === 'isChecked' || key === 'edited' || key.startsWith('_')) {
        delete tableItem[key]
      }
    })
  })
  return filteredTableValue
}

function convertValueFromClientToServer (value, type, recordProperties, propertyConfig) {
  if (type === 'objects') {
    value = value != null ? value.map(o => o.id || o.key) : null
  } else if (type === 'object') {
    value = value != null ? value.id || value.key : null
    // if (value != null) {
    // if (propertyConfig && propertyConfig.subType === 'vehicleProvision') {
    //   value = value.request.id
    // } else {
    // value = value.id || value.key
    // }
    // }
  } else if (type === 'number') {
    value = value || null
  } else if (type === 'boolean') {
    value = value != null ? value : null
  } else if (type === 'address') {
    value = value != null ? { id: value.id || value.key, value: value.value, regionId: value.region && value.region.id || null } : null
  } else if (type === 'table') {
    const valueToSave = {
      add: [],
      edit: [],
      remove: []
    }
    value.forEach(item => {
      let itemToServer = {}
      if (propertyConfig.convertItemToServer) {
        itemToServer = propertyConfig.convertItemToServer(item)
      } else {
        itemToServer = {}
        Object.keys(item).forEach(key => {
          itemToServer[key] = convertValueFromClientToServer(item[key], recordProperties && recordProperties[key] && recordProperties[key].type || typeof item[key])
        })
      }

      if (item.removed && item.id != null) {
        valueToSave.remove.push(item.id)
      }
      if (item.added && !item.removed) {
        valueToSave.add.push(itemToServer)
      }
      if (item.edited && item.id != null && !item.added) {
        valueToSave.edit.push(itemToServer)
      }
    })
    value = valueToSave
  }
  return value
}
